// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"204":"component---src-templates-homepage-tsx","234":"4b0f1969","282":"b7c758c8","400":"ebd36393","772":"973cd6d7"}[chunkId] + "-" + {"204":"78ff64a77559a4617e8e","234":"cd621ae0764ccca625dc","282":"28fa97a09c8e14358744","400":"f8e2bb2243c541c9e1dd","772":"73fd8689890787dee2de"}[chunkId] + ".js";
};